import React from 'react';
import { Link } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  return (
    <div className="w-full">

      {/* Banner Section */}
      <section className="relative h-[50vh] bg-gray-800 flex items-center justify-center">
        <img
          src="/images/aboutus/aboutus.jpg" // You can change this banner image
          alt="Privacy Banner"
          className="absolute inset-0 w-full h-full object-cover brightness-50"
        />
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-lg md:text-2xl">
            Your privacy is important to us. Learn how we collect and protect your data.
          </p>
        </div>
      </section>

      {/* Privacy Content Section */}
      <section className="py-16 bg-gray-100">
        <div className="max-w-6xl mx-auto px-4 space-y-12">
          
          {/* Introduction */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Introduction</h2>
            <p className="text-gray-700 text-lg md:text-xl">
              This Privacy Policy explains how we collect, use, and safeguard your personal information when you use our website and services.
            </p>
          </div>

          {/* Information Collection */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Information We Collect</h2>
            <p className="text-gray-700 text-lg md:text-xl mb-4">
              We may collect the following types of information:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Personal information such as name, email, phone number.</li>
              <li>Usage data such as pages visited, time spent on the site.</li>
              <li>Cookies and tracking technologies.</li>
            </ul>
          </div>

          {/* How We Use Information */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">How We Use Your Information</h2>
            <p className="text-gray-700 text-lg md:text-xl">
              The information we collect is used for:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Providing and improving our services</li>
              <li>Personalizing user experience</li>
              <li>Communicating updates, promotions, and support</li>
              <li>Ensuring website security</li>
            </ul>
          </div>

          {/* Data Protection */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Data Protection</h2>
            <p className="text-gray-700 text-lg md:text-xl">
              We implement appropriate security measures to protect your data from unauthorized access, disclosure, or alteration. We are committed to keeping your information safe.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Contact Us</h2>
            <p className="text-gray-700 text-lg md:text-xl mb-4">
              If you have any questions or concerns about our Privacy Policy, please feel free to reach out to us.
            </p>
            <Link
              to="/contact"
              className="inline-block px-6 py-3 bg-theme-color text-white font-bold rounded-lg hover:bg-red-700 transition duration-300"
            >
              Contact Support
            </Link>
          </div>

        </div>
      </section>

    </div>
  );
}
